// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__D0vvc","modalBody":"MealsPop_modalBody__EBNic"};